import themConfigs from 'config/theme';

const fullConfig = { theme: themConfigs };

export default {
  xs: `(max-width: ${parseInt(fullConfig.theme.screens.sm.slice(0, -2), 10) - 1}px)`,
  sm: `(min-width: ${fullConfig.theme.screens.sm}) and (max-width: ${
    parseInt(fullConfig.theme.screens.md.slice(0, -2), 10) - 1
  }px)`,
  md: `(min-width: ${fullConfig.theme.screens.md}) and (max-width: ${
    parseInt(fullConfig.theme.screens.lg.slice(0, -2), 10) - 1
  }px)`,
  lg: `(min-width: ${fullConfig.theme.screens.lg}) and (max-width: ${
    parseInt(fullConfig.theme.screens.xl.slice(0, -2), 10) - 1
  }px)`,
  xl: `(min-width: ${fullConfig.theme.screens.xl}) and (max-width: ${
    parseInt(fullConfig.theme.screens.xxl.slice(0, -2), 10) - 1
  }px)`,
  xxl: `(min-width: ${fullConfig.theme.screens.xxl})`,
};
